import { LogCache } from '@/modules/cache/log'
import { LogService } from '@/services/log-service'

export const _console = console

export class Log {
    static SUCCESS = 'success'
    static ERROR = 'error'
    static INFO = 'info'
    static WARNING = 'warning'
    static DEFAULT = 'default'

    /**
     * @type {LogCache}
     */
	static _cache = new LogCache
    static _subscribers = []
    static _interval = null

    static _log(type, message) {
    	Log._subscribers.forEach(subscriber => subscriber(type, message))

    	if (typeof message === 'object') {
    		try {
    			message = JSON.stringify(message)
    		} catch (e) {
    			return
    		}
    	}
        
    	if (typeof message !== 'string') {
    		message = `${message}`
    	}

    	message = message.substring(0, 1000) // Limit message length to 1000 characters

    	if (type === Log.ERROR || type === Log.WARNING || type === Log.SUCCESS)
    	    Log._cache.set({ type, message })
    }
    
    static async _uploadLogs() {
    	const logs = await Log._cache.list(0, 100)
    	if (logs.length === 0) 
    		return

    	const service = new LogService

    	try {
    		await service.upload(logs)
    		await Log._cache.remove(logs.map(log => log.uid))
    	} catch (e) {
    		_console.error('Failed to upload logs:', e)
    	}
    }

    static initLogUpload() {
    	Log._uploadLogs()

    	Log._interval = setInterval(() => {
    		Log._uploadLogs()
    	}, 1000 * 60 * 5) // every 5 minutes
    }

    static stopLogUpload() {
    	if (Log._interval) {
    		clearInterval(Log._interval)
    		Log._interval = null
    	}
    }
    
    static subscribe(callback) {
    	Log._subscribers.push(callback)
    }

    static unsubscribe(callback) {
    	Log._subscribers = Log._subscribers.filter(subscriber => subscriber !== callback)
    }

    static success(message) {
    	Log._log(Log.SUCCESS, message)
    }

    static error(message) {
    	Log._log(Log.ERROR, message)
    }

    static info(message) {
    	Log._log(Log.INFO, message)
    }

    static warning(message) {
    	Log._log(Log.WARNING, message)
    }
    
    static log(message) {
    	Log._log(Log.DEFAULT, message)
    }

    static async fetchAll() {
    	return (await Log._cache.all())
    		.sort((a, b) => a.timestamp < b.timestamp ? 1 : -1)
    		.map(log => ({ ...log, ...log.value }))
    }
}

const newConsole = {
	log: (...args) => {
		_console.log(...args)
		Log.log(args.map(a => JSON.stringify(a) || `${a}`).join(' '))
	},
	warn: (...args) => {
		_console.warn(...args)
		Log.warning(args.map(a => JSON.stringify(a) || `${a}`).join(' '))
	},
	error: (...args) => {
		_console.error(...args)
		Log.error(args.map(a => typeof a === 'object' ? JSON.stringify(a) : `${a}`).join(' '))
	},
	info: (...args) => {
		_console.info(...args)
		Log.info(args.map(a => JSON.stringify(a) || `${a}`).join(' '))
	},
}

window.console = newConsole